import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme: any) => ({
  configurationWrapper: {
    position: 'fixed',
    width: '100%',
    height: '100vh',
    background: 'rgba(0,0,0, 0.3)',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 999,
  },
  configurationPopup: {
    position: 'relative',
    background: theme.backgrounds.componentBackground,
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '4px',
    padding: 40,
    maxWidth: 400,
    width: '100%',
  },
  configurationPopupMobile: {
    padding: 20,
  },
  popupTitle: {
    textAlign: 'center',
    marginBottom: 30,
  },
  field: {
    width: '100%',
    marginBottom: 22,
    alignSelf: 'center',
  },
  resultTitle: {
    marginBottom: 40,
    marginRight: 20,
  },
  resultWrapper: {
    display: 'flex',
  },
  result: {
    color: '#8bc34a',
    textTransform: 'capitalize',
  },
  error: {
    color: 'red',
    textTransform: 'capitalize',
  },
  progressDots: {
    paddingTop: 3,
  },
  buttonsWrapper: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-around',
  },
  getButton: {
    width: 120,
  },
  setButton: {
    width: 120,
  },
  closeIconButton: {
    position: 'absolute',
    top: 5,
    right: 5,
  },
}))

export default useStyles
